export default "__VITE_ASSET__CoB8bHMm__"